// extracted by mini-css-extract-plugin
export default {"dashboard":"Home_dashboard__Ti0bw"};